import { useAngularContext } from 'AngularContext';
import { type LearnerContentCache } from './LearnerContentCache.types';

export function useLearnerContentCache() {
    const $injector = useAngularContext();
    return $injector.get<LearnerContentCache>('LearnerContentCache');
}
